<template>
    <common-modal v-if="isOpen" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="medium">
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.referrals.notes.add.notes_uploaded')"
                    :isCenter="true"
                    size="medium"
                ></common-page-header>
                <common-buttons>
                    <common-button
                        :label="$t('pages.referrals.notes.add.buttons.yes')"
                        type="primary"
                        size="large"
                        @click="reportAlreadyAdded()"
                    ></common-button>
                    <common-button
                        :label="$t('pages.referrals.notes.add.buttons.no')"
                        type="secondary"
                        size="large"
                        @click="goToAddReports()"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>
<script>
    import ReferralsAPI from 'api/ReferralsAPI'
    export default {
        props: {
            isOpen: { type: Boolean, required: true },
            referral: { type: Object, required: true },
        },

        methods: {
            reportAlreadyAdded() {
                ReferralsAPI.sendConsultationReport(this.referral.id, true).then(() => {
                    this.isUploading = false
                    this.emitEvent({ name: 'refresh-details' })
                    this.emitEvent({ name: 'close' })
                })
            },
            goToAddReports() {
                this.$router.push({
                    name: `referrals.received.add-report`,
                    params: {
                        id: this.referral.id,
                    },
                })
            },
        },
    }
</script>
